export const ATTR_VALUE = 'ATTR_VALUE_';